import { ToggleButton , FormGroup, FormLabel, MenuItem, Select, Stack, ToggleButtonGroup } from "@mui/material"
import Grid from '@mui/material/Unstable_Grid2';
import { useState } from "react";
import { TemplateData } from "../../../types";

interface YearlyScheduleBoxProps {
  template: TemplateData;
  setTemplate: (val: TemplateData) => void;
}

export const YearlyScheduleBox = ({ template, setTemplate }: YearlyScheduleBoxProps) => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  return (
    <Stack spacing={2}>
      <FormGroup>
        <FormLabel>Every</FormLabel>
        <ToggleButtonGroup
          color="primary"
          value={template.schedule?.repeat_period?.every_month ?? []}
          onChange={(e: any, val: string[]) => setTemplate({ ...template, schedule: { ...template.schedule ?? {}, repeat_period: { every_month: val } } })}
        >
          <Grid container spacing={1}>
            {
              months.map((month: string, index: number) => (
                <Grid xs={12/6}>
                <ToggleButton sx={{ width: '100%' }} value={index + 1}>{month}</ToggleButton >
              </Grid>
              ))
            }
          </Grid>
        </ToggleButtonGroup>
      </FormGroup>
      <FormGroup>
        <FormLabel>(Or) on the</FormLabel>
          <Stack direction="row" spacing={2}>
            <Select 
              value={template.schedule?.repeat_period?.or_week_number ?? ''}
              onChange={(e: any) => setTemplate({ ...template, schedule: { ...template.schedule ?? {}, repeat_period: { or_day_of_week: template.schedule?.repeat_period?.or_day_of_week, or_week_number: e.target.value } } })}
              sx={{ width: '200px' }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value="1">First</MenuItem>
              <MenuItem value="2">Second</MenuItem>
              <MenuItem value="3">Third</MenuItem>
              <MenuItem value="4">Fourth</MenuItem>
            </Select>
            <Select 
              sx={{ width: '200px' }}
              value={template.schedule?.repeat_period?.or_day_of_week ?? ''}
              onChange={(e: any) => setTemplate({ ...template, schedule: { ...template.schedule ?? {}, repeat_period: { or_week_number: template.schedule?.repeat_period?.or_week_number, or_day_of_week: e.target.value } } })}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value="monday">Monday</MenuItem>
              <MenuItem value="tuesday">Tuesday</MenuItem>
              <MenuItem value="wednesday">Wednesday</MenuItem>
              <MenuItem value="thursday">Thursday</MenuItem>
              <MenuItem value="friday">Friday</MenuItem>
              <MenuItem value="saturday">Saturday</MenuItem>
              <MenuItem value="sunday">Sunday</MenuItem>
            </Select>
          </Stack>
      </FormGroup>
    </Stack>
  )
}